import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "./nodata.module.css";
function NoData({ title, message }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: { xs: "50vh", sm: "calc(100vh - 200px)" },
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <img src="/assets/nodata.svg" alt="No Data" className={styles.image} />
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="h4"
          sx={{ mb: 1 }}
          fontWeight={700}
          className={styles.heading}
        >
          {title}
        </Typography>
        <Typography variant="body1" className={styles.paragraph}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
}

export default NoData;
